<script setup>
  import { computed } from 'vue';
  import { useMapStore } from "@/stores/MapStore";
  import { useProductStore } from "@/stores/ProductStore";
  import MapButton from "@/components/MapButton.vue";

  const props = defineProps({
    product: {
      type: Object,
      required: true
    }
  });

  const mapStore = useMapStore();
  const productStore = useProductStore();

  const hasUpgrade = computed(() => productStore.hasProductUpgrade(parseInt(props.product.id)));
  const disabled = computed(() => !productStore.getProduct(parseInt(props.product.id)) || hasUpgrade.value);

  const classObject = computed(() => ({
    selected: parseInt(mapStore.state.id) === parseInt(props.product.id)
  }));
  
  function handleCick() {
    mapStore.mapProductUpdate(props.product);
  }

</script>

<template>
  <MapButton 
    @click.prevent="handleCick"
    :class="classObject"
    :accessibleLabel="props.product.name"
    :disabled="disabled"
    pinned
  >
    <slot></slot>
  </MapButton>
</template>